import {FlagProps} from 'platform/components';

import {TireStatus} from '../types/TireStatus';

export const getEditTireSetFlags = (
  tireSetStatus: TireStatus,
  tireSetRequestStatus: TireStatus
): FlagProps[] => {
  const tireSetFlags =
    tireSetStatus.label && tireSetStatus.colorScheme
      ? [{label: tireSetStatus.label, colorScheme: tireSetStatus.colorScheme}]
      : [];

  const tireSetRequestFlags =
    tireSetRequestStatus.label && tireSetRequestStatus.colorScheme
      ? [
          {
            label: tireSetRequestStatus.label,
            colorScheme: tireSetRequestStatus.colorScheme,
            isSubtle: true,
          },
        ]
      : [];

  return tireSetFlags.concat(tireSetRequestFlags);
};
